<script lang="ts" setup>
import { useTrainingPartnersStore } from "~/store/training-partners/training-partners.store";
import CenterModal from "~/components/Common/Modals/CenterModal.vue";
import EditFileUploadLogo from "~/components/Common/Upload/EditFileUploadLogo.vue";
import AreaInput from "~/components/Common/Inputs/AreaInput.vue";
import AppButton from "~/components/Common/Buttons/AppButton.vue";

const trainingPartnerStore = useTrainingPartnersStore();
const { editTrainingPartner } = storeToRefs(trainingPartnerStore);

const errors = ref({
  name: false,
});

const save = async () => {
  if (editTrainingPartner.value.name) errors.value.name = false;
  else errors.value.name = true;

  if (!errors.value.name && editTrainingPartner.value.id) {
    await trainingPartnerStore.updateTrainingPartnerSimbelAdmin(editTrainingPartner.value.id).then(() => {
      trainingPartnerStore.closeModal();
    });
  }
};
</script>

<template>
  <CenterModal
    style="max-width: 720px; max-height: 688px; width: 100%; height: 100%"
    @hide="trainingPartnerStore.closeModal()"
  >
    <template #body>
      <div class="off_catalog__modal body_regular">
        <HeaderDetails
          class="py-4"
          :with-shadow="false"
          back-icon="arrow_left"
          :close="false"
          back
          @back-click="trainingPartnerStore.closeModal()"
        >
        </HeaderDetails>

        <div class="overflow-y-scroll h-full px-[64px] pt-14 flex flex-col">
          <span class="heading_4_med mb-[40px]">Général</span>
          <div class="flex flex-col gap-4">
            <div class="gap-[4px] flex flex-col w-full">
              <span class="body_regular text-secondary-color">Nom de l'organisme*</span>
              <input
                v-model="editTrainingPartner.name"
                type="text"
                class="input__default body_regular w-full"
                placeholder="Saisir le nom de l'organisme'"
                :data-error="errors.name"
              />
            </div>
            <div class="flex gap-4">
              <div class="gap-[4px] flex flex-col w-full">
                <span class="body_regular text-secondary-color">Prénom du contact</span>
                <input
                  v-model="editTrainingPartner.mainContactFirstname"
                  type="text"
                  class="input__default body_regular w-full"
                  placeholder="Saisir le prénom du contact'"
                />
              </div>
              <div class="gap-[4px] flex flex-col w-full">
                <span class="body_regular text-secondary-color">Nom du contact</span>
                <input
                  v-model="editTrainingPartner.mainContactLastname"
                  type="text"
                  class="input__default body_regular w-full"
                  placeholder="Saisir le nom du contact'"
                />
              </div>
            </div>
            <div class="gap-[4px] flex flex-col w-full">
              <span class="body_regular text-secondary-color">Mail du contact</span>
              <input
                v-model="editTrainingPartner.mainContactEmail"
                type="text"
                class="input__default body_regular w-full"
                placeholder="Saisir l'email du contact'"
              />
            </div>
            <div class="gap-[4px] flex flex-col w-full">
              <span class="body_regular text-secondary-color">Mentions légales</span>
              <AreaInput
                v-model="editTrainingPartner.legalNotice"
                class="textarea__input overflow-auto text-area"
                placeholder="Saisir les mentions légales'"
              ></AreaInput>
            </div>

            <div class="gap-[4px] flex flex-col w-full">
              <span class="body_regular text-secondary-color">Logo</span>
              <EditFileUploadLogo v-model="editTrainingPartner.logo"></EditFileUploadLogo>
            </div>
          </div>
        </div>
        <footer class="off_catalog__footer_container">
          <AppButton type="outlined" label="Annuler" class="w-full" @click="trainingPartnerStore.closeModal()" />
          <AppButton label="Sauvegarder" class="w-full" @click="save" />
        </footer>
      </div>
    </template>
  </CenterModal>
</template>

<style scoped lang="scss">
@use "assets/scss/texts";

.off_catalog__footer_container {
  @apply flex items-center px-[64px] w-full flex-row justify-between gap-[16px];
  height: 68px;
  min-height: 68px;
  border-top: 1px solid var(--grey-lightest);
}

@media (max-width: 748px) {
  .off_catalog__footer_container {
    @apply px-[12px];
  }
}

.off_catalog__modal {
  @apply flex flex-col h-full;
}

@media (max-width: 748px) {
  .request_button_footer {
    @apply w-full;
  }
}

.request_button_footer {
  @apply body_med;
}
</style>
